import houseOneImage from "../../../../assets/sellWithUs/house1.png";
import houseTwoImage from "../../../../assets/sellWithUs/house2.png";
import houseThreeImage from "../../../../assets/sellWithUs/house3.png";
import { Box, Typography, useMediaQuery, Theme, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/mousewheel";
import "swiper/css/pagination";

export const GalleryBlocks = () => {
  const navigate = useNavigate();
  const { t } = useTranslation(["sellWithUs"]);
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        width: `calc(100vw - ${downMd ? "0" : "20px"})`,
        flex: "1",
        padding: "0 20px",
        boxSizing: "border-box",
        mt: "20px",
        direction: isRTL ? "rtl" : "ltr",
      }}
    >
      <Swiper
        key={isRTL ? "rtl" : "ltr"}
        modules={[Mousewheel]}
        slidesPerView={"auto"}
        spaceBetween={downMd ? 20 : 25}
        mousewheel={{ forceToAxis: true }}
        className={`sell-w-u-gallery-block-swiper ${
          isRTL ? "sell-w-u-gallery-slide-rtl" : "sell-w-u-gallery-slide-ltr"
        } `}
      >
        <SwiperSlide>
          <Box
            sx={{
              position: "relative",
              borderRadius: "20px",
              overflow: "hidden",
              height: downMd ? "310px" : "400px",
              background: `url(${houseOneImage}) center center / cover no-repeat`,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                top: 0,
                width: "100%",
                p: downMd ? "20px" : "30px",
                background:
                  "linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0))",
                color: "white",
                textAlign: isRTL ? "right" : "left",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                boxSizing: "border-box",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  flexGrow: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "22px", md: "26px" },
                    fontWeight: "500",
                    fontFamily: isRTL ? "Noto Sans Hebrew" : "DM sans",
                    lineHeight: "30px",
                  }}
                >
                  {t("edge")}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  background: "linear-gradient(to right, #034A73, #0A7992)",
                  p: "10px 18px",
                  cursor: "pointer",
                  borderRadius: "24px",
                  gap: "8px",
                  flexDirection: isRTL ? "row-reverse" : "row",
                  padding: "16px 27.5px",
                  width: "fit-content",
                }}
                onClick={() => navigate("/contact-us")}
              >
                <Typography
                  sx={{
                    fontFamily: isRTL ? "Noto Sans Hebrew" : "DM Sans",
                    fontWeight: isRTL ? 400 : 500,
                    lineHeight: "16px",
                    fontSize: "16px",
                  }}
                >
                  {t("get_started")}
                </Typography>
              </Box>
            </Box>
          </Box>
        </SwiperSlide>
        <SwiperSlide>
          <Box
            sx={{
              position: "relative",
              borderRadius: "20px",
              overflow: "hidden",
              boxSizing: "border-box",
              height: downMd ? "310px" : "400px",
              background: `url(${houseTwoImage}) center center / cover no-repeat`,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                top: 0,
                width: "100%",
                p: downMd ? "20px" : "30px",
                background:
                  "linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0))",
                color: "white",
                textAlign: isRTL ? "right" : "left",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                boxSizing: "border-box",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  flexGrow: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "22px", md: "26px" },
                    fontWeight: "500",
                    fontFamily: isRTL ? "Noto Sans Hebrew" : "DM sans",
                    lineHeight: "30px",
                  }}
                >
                  {t("team")}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  background: "linear-gradient(to right, #034A73, #0A7992)",
                  p: "10px 18px",
                  cursor: "pointer",
                  borderRadius: "24px",
                  gap: "8px",
                  flexDirection: isRTL ? "row-reverse" : "row",
                  padding: "16px 27.5px",
                  width: "fit-content",
                }}
                onClick={() => navigate("/contact-us")}
              >
                <Typography
                  sx={{
                    fontFamily: isRTL ? "Noto Sans Hebrew" : "DM Sans",
                    fontWeight: isRTL ? 400 : 500,
                    lineHeight: "16px",
                    fontSize: "16px",
                  }}
                >
                  {t("get_started")}
                </Typography>
              </Box>
            </Box>
          </Box>
        </SwiperSlide>
        <SwiperSlide>
          <Box
            sx={{
              position: "relative",
              borderRadius: "20px",
              overflow: "hidden",
              boxSizing: "border-box",
              height: downMd ? "310px" : "400px",
              background: `url(${houseThreeImage}) center center / cover no-repeat`,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                top: 0,
                width: "100%",
                p: downMd ? "20px" : "30px",
                background:
                  "linear-gradient(to bottom, rgba(0,0,0,0.7), rgba(0,0,0,0))",
                color: "white",
                textAlign: isRTL ? "right" : "left",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                boxSizing: "border-box",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  flexGrow: 1,
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "22px", md: "26px" },
                    fontWeight: "500",
                    fontFamily: isRTL ? "Noto Sans Hebrew" : "DM sans",
                    lineHeight: "30px",
                  }}
                >
                  {t("market")}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  background: "linear-gradient(to right, #034A73, #0A7992)",
                  p: "10px 18px",
                  cursor: "pointer",
                  borderRadius: "24px",
                  gap: "8px",
                  flexDirection: isRTL ? "row-reverse" : "row",
                  padding: "16px 27.5px",
                  width: "fit-content",
                }}
                onClick={() => navigate("/contact-us")}
              >
                <Typography
                  sx={{
                    fontFamily: isRTL ? "Noto Sans Hebrew" : "DM Sans",
                    fontWeight: isRTL ? 400 : 500,
                    lineHeight: "16px",
                    fontSize: "16px",
                  }}
                >
                  {t("get_started")}
                </Typography>
              </Box>
            </Box>
          </Box>
        </SwiperSlide>

        <div className="swiper-pagination"></div>
      </Swiper>
    </Box>
  );
};
